import React, { useState, useEffect } from "react";
import { X } from "lucide-react";
import GameCanvas from "./GameCanvas";
import StartScreen from "./components/StartScreen";
import { getHighScore, setHighScore } from "./utils/scoreManager";

const FlappyTrade = ({ onClose }) => {
  const [gameState, setGameState] = useState("start"); // start, playing, gameOver
  const [score, setScore] = useState(0);
  const [highScore, setHighScoreState] = useState(getHighScore());

  const handleGameOver = (finalScore) => {
    setScore(finalScore);
    if (finalScore > highScore) {
      setHighScore(finalScore);
      setHighScoreState(finalScore);
    }
    setGameState("gameOver");
  };

  const startGame = () => {
    setScore(0);
    setGameState("playing");
  };

  return (
    <div className="game-modal-overlay">
      <div className="game-modal">
        <button className="game-close-button" onClick={onClose}>
          <X size={24} />
        </button>

        <div className="game-container">
          {gameState === "start" && (
            <StartScreen highScore={highScore} onStart={startGame} />
          )}

          {gameState === "playing" && (
            <GameCanvas onGameOver={handleGameOver} onScoreChange={setScore} />
          )}

          {gameState === "gameOver" && (
            <div className="game-over-screen">
              <h2>Game Over!</h2>
              <p>Score: {score}</p>
              <p>High Score: {highScore}</p>
              <button onClick={startGame}>Play Again</button>
            </div>
          )}

          <div className="game-score">Score: {score}</div>
        </div>
      </div>
    </div>
  );
};

export default FlappyTrade;
